export default {"src":"/_next/static/media/header-logo.52effa10.svg","height":45,"width":84,"blurWidth":0,"blurHeight":0};